export default __webpack_public_path__ + "static/eye_wash_w.b5314f513c0b414fe4a1dfa462f9291c.png";